import { requestAppUpdate } from "@/pwa/runtime";
import { isAppNavigation } from "@/pwa/routes";

/** A missing chunk can mean the server has a newer build. Recover silently,
 * once per short interval so a genuinely broken screen cannot cause a loop. */
const RETRIED_AT = "pm-stale-build-reload";
const PATTERNS = [
    "Failed to fetch dynamically imported module",
    "error loading dynamically imported module",
    "Importing a module script failed",
    "Unable to preload CSS",
];

export function isStaleBuild(error: unknown): boolean {
    const message = error instanceof Error ? error.message : String(error ?? "");
    return PATTERNS.some((pattern) => message.includes(pattern));
}

export function recoverStaleBuild(): boolean {
    if (!navigator.onLine || !isAppNavigation(new URL(window.location.href))) return false;
    try {
        const last = Number(window.sessionStorage.getItem(RETRIED_AT) || 0);
        if (Date.now() - last < 15_000) return false;
        window.sessionStorage.setItem(RETRIED_AT, String(Date.now()));
    } catch {
        // Without storage, leave the ordinary retry button available instead.
        return false;
    }
    void requestAppUpdate();
    return true;
}
